import { useCallback } from "react";
import useOrgId from "@/components/FpAppV4/hooks/useOrgId";
import useWebsocketRoom from "@/components/FpAppV4/hooks/useWebsocketRoom";

/**
 * Data received from UNGREY_FILE_UPLOAD WebSocket message
 */
export interface FileStatusUpdate {
  taskId: string;
  blobId: string;
  status: string;
  // Optional fields - available when file metadata exists
  filesystemPath?: string[];
  fileName?: string;
  fileType?: string;
  uploadedAt?: string;
  documentDate?: string;
  isBlob?: boolean;
  isPasswordProtected?: boolean;
  hasStoredPassword?: boolean;
  driveId?: string;
  documentTypes?: string[];
}

interface WebSocketMessage {
  message_type: string;
  message_data: FileStatusUpdate;
}

/**
 * Hook to subscribe to file status updates via WebSocket.
 * Listens for UNGREY_FILE_UPLOAD messages on the organization room.
 */
export function useFileStatusUpdates(
  onFileStatusChange: (update: FileStatusUpdate) => void
) {
  const orgId = useOrgId();

  const handleMessage = useCallback(
    (message: unknown) => {
      const wsMessage = message as WebSocketMessage;
      if (wsMessage.message_type === "UNGREY_FILE_UPLOAD") {
        onFileStatusChange(wsMessage.message_data);
      }
    },
    [onFileStatusChange]
  );

  useWebsocketRoom("organization", orgId, null, handleMessage);
}
